import React, { useContext, useEffect, useState } from 'react';
import English from '../../../../../../assets/icons/english-language.svg';
import French from '../../../../../../assets/icons/french-language.svg';
import German from '../../../../../../assets/icons/german-language.svg';
import Spanish from '../../../../../../assets/icons/spanish-language.svg';
import Arrow from 'assets/icons/arrow-language-selector.svg?react';
import { useScopedTranslation } from '../../../../../../application/localization/useScopedTranslation.ts';
import styles from './toolbar.module.scss';
import clsx from 'clsx';
import { Language } from '../../../../../../services/api/api-client.types.ts';
import { PageDesignerContext } from '../../../DesignerNewPage.tsx';
import { tDynamic } from '../../../../../../helpers/tDynamic.ts';

type LanguageItem = {
  image: string;
  text: string;
  value: Language;
};

const languages: LanguageItem[] = [
  {
    image: German,
    text: 'deutsch',
    value: Language.De,
  },
  {
    image: English,
    text: 'english',
    value: Language.En,
  },
  {
    image: French,
    text: 'french',
    value: Language.Fr,
  },
  {
    image: Spanish,
    text: 'spanish',
    value: Language.Es,
  },
];

export const LanguageSelector = () => {
  const i18n = useScopedTranslation('Page.LanguageSelector');
  const pageDesignerContext = useContext(PageDesignerContext);

  const [isOpened, setIsOpened] = useState(false);

  const selectedLanguageImage = languages.find(
    (language) => language.value === pageDesignerContext?.pageEditorLanguage,
  )?.image;

  useEffect(() => {
    const closePopup = () => setIsOpened(false);

    document.body.addEventListener('click', closePopup);

    return () => document.body.removeEventListener('click', closePopup);
  }, []);

  return (
    <div className={styles.relative}>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setIsOpened((prevState) => !prevState);
        }}
        className={styles.languageSelectorContainer}
      >
        <img className={styles.languageIcon} src={selectedLanguageImage} />
        <Arrow className={clsx(isOpened && styles.reverted)} />
      </div>
      {isOpened && (
        <div className={styles.languagesList}>
          {languages.map((language) => (
            <div
              key={language.value}
              className={clsx(
                styles.languageItem,
                language.value === pageDesignerContext?.pageEditorLanguage &&
                  styles.currentLanguage,
              )}
              onClick={() => {
                pageDesignerContext?.onEditorLanguageChange(language.value);
              }}
            >
              <img src={language.image} />
              <div>{tDynamic(i18n, language.text)}</div>
              {language.value === pageDesignerContext?.defaultLanguage && (
                <div className={styles.defaultLanguage}>
                  {i18n.t('default')}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
